import useLocale from 'next-translate/useTranslation';

import clsxm from '@/lib/clsxm';

import type { ToolBadge } from '@/constants/toolCategories';

const STYLES: Record<ToolBadge, string> = {
  new: 'bg-primary-100 text-primary-700 dark:bg-primary-500/20 dark:text-primary-300',
  beta: 'bg-emerald-100 text-emerald-700 dark:bg-emerald-500/20 dark:text-emerald-300',
};

const LABELS: Record<ToolBadge, string> = {
  new: 'New',
  beta: 'Beta',
};

interface NavBadgeProps {
  type: ToolBadge;
  className?: string;
}

/** Small status pill shown next to navigation items (New / Beta). */
const NavBadge: React.FC<NavBadgeProps> = ({ type, className }) => {
  const { t } = useLocale('dashboard');

  return (
    <span
      className={clsxm(
        'rounded-full px-1.5 py-0.5 text-[10px] font-semibold leading-none',
        STYLES[type],
        className,
      )}
    >
      {t(LABELS[type])}
    </span>
  );
};

export default NavBadge;
